import React from 'react';
import cx from 'classnames';
import {CheckBox, Flex, Text} from '@priority-software/priority-style-react';
import texts from '../texts';
import style from '../styles/multiCompaniesSelect.module.scss';

export const SelectHeader = ({store, filteredCompanies, isAllSelected}) => {
    const counterText = texts.selectedNum.replace('XXX', store.selectedCompaniesCount);

    const selectAllHandler = () => {
        store.setAllSelected(filteredCompanies);
    };

    return (
        <Flex>
            <CheckBox
                componentClasses={cx(style.selectHeader, 'text-caption-1')}
                disabled={!filteredCompanies.length}
                checked={isAllSelected}
                onChange={selectAllHandler}
            >
                {texts.selectAll}
            </CheckBox>
            <Text skin={'caption-1'}>{counterText}</Text>
        </Flex>
    );
};
